import script from "./ContractDocumentView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractDocumentView.vue?vue&type=script&setup=true&lang=ts"

import "./ContractDocumentView.vue?vue&type=style&index=0&id=193f76f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-193f76f8"]])

export default __exports__